import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import Tabs from './Tabs';

const SubMenu: React.FunctionComponent = () => {
  const { t } = useTranslation();

  const location = useLocation();
  const mainLocation = location.pathname.split('/')[1];

  const contractsTabs = [
    {
      label: t('header:navigation.contractsSubLink'),
      key: 'contracts',
      link: '/contracts',
    },
    {
      label: t('header:navigation.manageContractsSubLink'),
      key: 'manageContracts',
      link: '/contracts/manage',
      mobile: false,
    },
    {
      label: t('header:navigation.manageContractsSubLinkMobile'),
      key: 'manageContractsMobile',
      link: '/contracts/manage',
      mobile: true,
    },
  ];
  const newsTabs = [
    {
      label: t('common:news.benefitsTab'),
      key: 'benefits',
      link: '/news/benefits',
    },
    {
      label: t('common:news.newsTab'),
      key: 'news',
      link: '/news',
    },
    {
      label: t('common:news.articlesTab'),
      key: 'articles',
      link: '/news/articles',
    },
  ];
  const customerServiceTabs = [
    {
      label: t('header:navigation.faqSublink'),
      key: 'faq',
      link: '/customerService',
    },
    {
      label: t('header:navigation.contactSublink'),
      key: 'contact',
      link: '/customerService/contact',
    },
  ];
  const spotPriceFixingTabs = [
    {
      label: t('header:navigation.spotFixCurrentSublink'),
      key: 'current',
      link: '/spotPriceFixing',
    },
    {
      label: t('header:navigation.spotFixUpcomingSublink'),
      key: 'upcoming',
      link: '/spotPriceFixing/upcoming',
    },
    {
      label: t('header:navigation.spotFixHistorySublink'),
      key: 'history',
      link: '/spotPriceFixing/history',
    },
  ];

  let desiredSubmenu = <></>;
  switch (mainLocation) {
    case 'contracts':
      desiredSubmenu = <Tabs tabs={contractsTabs} />;
      break;
    case 'news':
      desiredSubmenu = <Tabs tabs={newsTabs} />;
      break;
    case 'customerService':
      desiredSubmenu = <Tabs tabs={customerServiceTabs} />;
      break;
    case 'spotPriceFixing':
      desiredSubmenu = <Tabs tabs={spotPriceFixingTabs} />;
      break;
  }

  return <>{desiredSubmenu}</>;
};

export default SubMenu;
